<template>
  <v-sheet tag="section" :class="(this.$route.name.match(/PickupPackages/))? $vuetify.breakpoint.smAndDown? 'mb-8' : 'mb-15': ''">
    <v-row v-if="(!hideTitle && this.$route.name.match(/PickupPackages/))"  class="form-item-heading" :class="headingBgColor">
      <v-subheader class="text-subtitle-1 align-center" :class="[headingTextColor ? `${headingTextColor}--text` : null, headingPadding, {'font-weight-bold': isHeadingTextBold}]">
        {{title}}
      </v-subheader>
    </v-row>
    <slot name="pickup"></slot>
    <vb-form-row item-name="箱数" :required="true">
      <template #input>
        <validation-provider
            v-slot="{ errors }"
            name="箱数"
            :rules="`required|between:1,${maxNumberOfPackages}`"
            :immediate="true"
        >
          <template v-if="isNumberOfPackagesSelectable">
            <v-sheet class="mb-4" max-width="110px">
              <v-select
                  :value="formItems.numberOfPackages"
                  @input="updateFormItems({name:'numberOfPackages', value: Number($event)})"
                  :items="numberOfPackages"
                  name="numberOfPackages"
                  :error-messages="errors"
                  required
                  dense
                  height="44px"
                  hide-details="auto"
                  outlined
                  class="my-3 pa-0 align-center"
                  :background-color="errors[0] ? 'red lighten-5' : 'accent2'"
              >
                <template #append-outer>箱</template>
              </v-select>
            </v-sheet>
            <p v-if="!isCharibon" class="text-caption grey--text text--darken-4 pl-0 mb-0">
              <slot v-if="$scopedSlots.annotation" name="annotation" />
              <template v-else>{{ (formLabels.isShippingFree || formLabels.isShippingFreeAutoApplication) ? "クーポン適用につき送料無料です" : "1箱につき、" + shippingCost + "円の送料が査定額から引かれます" }}</template>
              </p>
          </template>
          <template v-else>
            <v-sheet class="mb-4" max-width="110px">
              <v-text-field
                  :value="formItems.numberOfPackages"
                  requied
                  :error-messages="errors"
                  dense
                  height="44px"
                  hide-details="auto"
                  outlined
                  class="my-3 pa-0 align-center"
                  :readonly="true"
                  :maxlength="maxNumberOfPackagesLength"
                  :background-color="errors[0] ? 'red lighten-5' : 'accent2'"
              >
                <template #append-outer>箱</template>
              </v-text-field>
            </v-sheet>
            <p class="text-caption grey--text text--darken-4 pl-0 mb-0">{{ numberOfPackages[0] }}箱での申込をお願いいたします</p>
          </template>
        </validation-provider>
      </template>
    </vb-form-row>
    <vb-form-row item-name="集荷希望日時" :required="true">
      <template #input>
        <v-row no-gutters>
          <v-col cols="12" class="px-0 pt-0 pb-3">
            <validation-provider v-slot="{ errors }" name="日にち" rules="required">
              <v-sheet max-width="372">
                <v-select
                    v-model="selectedPickupDate"
                    :items="pickupDates"
                    item-text="name"
                    item-value="value"
                    :error-messages="errors"
                    label="日にち"
                    name="pickupDate"
                    required
                    dense
                    height="44px"
                    hide-details="auto"
                    outlined
                    solo
                    flat
                    ref="pickupDate"
                    :background-color="errors[0] ? 'red lighten-5' : 'accent2'"
                >
                  <template #prepend v-if="$vuetify.breakpoint.mdAndUp">
                    <v-chip label color="white" class="text-subtitle-1 pa-0 ma-0 mr-6">日にち</v-chip>
                  </template>
                </v-select>
              </v-sheet>
            </validation-provider>
          </v-col>
          <v-col cols="12" class="px-0 pt-3 pb-0">
            <validation-provider v-slot="{ errors }" name="時間帯" rules="required">
              <v-sheet max-width="372">
                <v-select
                    v-model="selectedPickupTime"
                    :items="pickupTimesForADay"
                    item-text="name"
                    item-value="value"
                    return-object
                    :error-messages="errors"
                    label="時間帯"
                    name="pickupTimeCode"
                    required
                    dense
                    height="44px"
                    hide-details="auto"
                    outlined
                    solo
                    flat
                    :background-color="errors[0] ? 'red lighten-5' : 'accent2'"
                >
                  <template #prepend v-if="$vuetify.breakpoint.mdAndUp">
                    <v-chip label color="white" class="text-subtitle-1 pa-0 ma-0 mr-6">時間帯</v-chip>
                  </template>
                </v-select>
              </v-sheet>
            </validation-provider>
          </v-col>
        </v-row>
      </template>
    </vb-form-row>
  </v-sheet>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import VbFormRow from "../../molecules/buy/vb-form-row.vue";

export default {
  name: "pickup-packages",
  components: {VbFormRow},
  inject: ['setErrors'],
  props: {
    headingBgColor: {type: String, default: null},
    headingTextColor: {type: String, default: null},
    headingPadding: {type: String, default: null},
    isHeadingTextBold: {type: Boolean, default: false},
    maxNumberOfPackages: {
      type: Number,
      required: true,
    },
    pickupRequestCutOffTimeOffsetInHours: {
      type: Number,
      required: false,
      default: null,
    },
    hideTitle: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      shippingFee: null,
      numberOfPackages: Array.from({length: this.maxNumberOfPackages}, (_, v) => v + 1),
      maxNumberOfPackagesLength: String(this.maxNumberOfPackages).length,
      pickupDates: [],
      pickupTimes: [],
    }
  },
  created: function () {
    this.preparePickup();
  },
  computed: {
    ...mapGetters({
        getBuyFormItems: 'buy/getFormItems',
        getBuyFormLabels: 'buy/getFormLabels',
    }),
    formItems() {
        return this.getBuyFormItems;
    },
    formLabels() {
        return this.getBuyFormLabels;
    },
    title() {
      if ([VueConfig.siteCode.charibon, VueConfig.siteCode.vaboo].includes(this.$siteCode)) {
        return '集荷箱数・集荷日時';
      }
      return '集荷日';
    },
    isNumberOfPackagesSelectable() {
      return 1 < this.numberOfPackages.length;
    },
    isCharibon() {
      return this.$siteCode === VueConfig.siteCode.charibon;
    },
    shippingCost(){
      return VueConfig.sell.shippingFeePerPackage;
    },
    pickupTimesForADay() {
      if (this.formItems.pickupDate) {
        return this.pickupTimes[this.formItems.pickupDate];
      }
      return [];
    },
    selectedPickupDate: {
      get() {
        return this.formItems.pickupDate;
      },
      set(pickupDate) {
        this.updateFormItems({name: 'pickupDate', value: pickupDate});
        this.selectedPickupTime = this.pickupTimes[pickupDate][0];
      }
    },
    selectedPickupTime: {
      get() {
        return {name: this.formLabels.pickupPeriodName, value: this.formItems.pickupTimeCode};
      },
      set(pickupTime) {
        this.updateFormItems({name: 'pickupTimeCode', value: pickupTime.value});
        this.updateFormLabels({name: 'pickupPeriodName', value: pickupTime.name});
      }
    },
  },
  methods: {
    ...mapActions('buy', [
      'updateFormItems',
      'updateFormLabels'
    ]),
    preparePickup() {
      const query = this.pickupRequestCutOffTimeOffsetInHours
          ? `?pickup_request_cut_off_time_offset_in_hours=${this.pickupRequestCutOffTimeOffsetInHours}`
          : '';

      axios.get(`/api/ajax/pickup-time${query}`).then(response => {
        this.pickupTimes = this.buildPickupTimes(response.data);
        const dates = Object.keys(this.pickupTimes);
        dates.sort();
        for (let date of dates) {
          this.pickupDates.push(this.buildPickupDate(date))
        }
        if (!this.selectedPickupDate) {
          this.selectedPickupDate = this.pickupDates[0].value;
        }
        if (!dates.includes(this.selectedPickupDate)) {
          this.selectedPickupDate = this.pickupDates[0].value;
        }
      });
    },
    buildPickupDate(iso8601YMD) {
      let date = new Date(Date.parse(iso8601YMD));
      let dateString = date.toLocaleDateString('ja-JP', {dateStyle: 'long'});
      let dayString = date.toLocaleDateString('ja-JP', {weekday: 'short'});
      return {
        'name': `${dateString}(${dayString})`,
        'value': iso8601YMD
      };
    },
    buildPickupTimes(response) {
      const pickupTimes = {};
      for (const [date, periods] of Object.entries(response)) {
        for (const period of periods) {
          if (!pickupTimes.hasOwnProperty(date)) {
            pickupTimes[date] = [];
          }
          pickupTimes[date].push({
            "name": period.periodName,
            "value": period.code,
          })
        }
      }
      return pickupTimes;
    },
    routeResolve(name) {
      const route = this.$router.resolve({
        name: name,
      }).href
      if(this.$routerBase){
        const reg = new RegExp("^" + this.$routerBase);
        const url = route.replace(reg, "")
        return '/' + url
      } else {
        return route
      }
    },
    scrollToPickupDateTime() {
      this.$vuetify.goTo(this.$refs.pickupDate, {
        duration: 300,
        offset: window.innerHeight / 2,
        easing: 'easeInOutCubic'
      })
      setTimeout(() => {
        this.setError("日にち", "ご指定の集荷希望日は選択できません。")
      }, 500);
    },
    setError(name, errorMessage){
      let params = {};
      params[name] = errorMessage;
      this.setErrors(params);
    },
  }
}
</script>

<style scoped lang="scss">
.row {
  margin-top: 0;
  margin-bottom: 0;
}
.specify-border {
    position: relative;
    &:after {
        content: "";
        display: block;
        border-top: 1px solid #FBFAF5;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
    }
}
</style>